import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import {
  Button,
  ConfigProvider,
  Modal, Space,
  Table,Tooltip
} from "antd";
import {HomeStore,CommonStore} from "../../store";
import Column from "antd/es/table/Column";
import dictionary from "../../utils/dictionary";

function ApprovalDetails(props: any) {
  return (
    <Fragment>
      <Modal
        width={"70%"}
        centered
        title={"审批详情"}
        open={HomeStore.approvalModal.isOpen}
        destroyOnClose={true}
        footer={null}
        onCancel={() => HomeStore.approvalModal.close()}
        loading={HomeStore.approvalLoadModal}
      >
        <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
          <Table
            dataSource={HomeStore.approvalDataModal}
            rowKey={(record: any) => record.customNodeId}
            loading={HomeStore.approvalLoadModal}
            scroll={{ x: 1000}}
            size="small"
            className="tableSty"
            pagination={false}
          >
            <Column
              ellipsis={true}
              width={120}
              title="节点名称"
              dataIndex="nodeName"
            />
            <Column
              ellipsis={true}
              width={120}
              title="审批人"
              dataIndex="username"
            />
            <Column
              ellipsis={true}
              width={120}
              title="审批结果"
              dataIndex="result"
            />
            <Column
              ellipsis={true}
              width={120}
              title="审批状态"
              dataIndex="status"
              render={(status) => dictionary.approvalStatus[status]}
            />
            <Column
              ellipsis={true}
              width={200}
              title="审批时间"
              dataIndex="approvalTime"
            />
            <Column
              ellipsis={true}
              width={150}
              title="审批人列表"
              dataIndex="users"
              render={(users) =>
                users && users.map((list: any) => list.username).join(",")
              }
            />
            <Column
              title="审批意见"
              width={150}
              ellipsis={true}
              dataIndex="comment"
              render={(comment) => (
                  (<Tooltip placement="topLeft" title={comment}>
                    {comment}
                  </Tooltip>)
              )}
            />
            <Column
                width={100}
                fixed={"right"}
                align={'right'}
                render={(text: string, record: any) => (
                    <Space>
                      {record.subNodes &&record.subNodes.length>0 &&<Button size={"small"} onClick={() => HomeStore.subNodesModal.open('account',record)}>
                        查看子节点
                      </Button>}
                    </Space>
                )}
            />
          </Table>
        </ConfigProvider>
      </Modal>

      <Modal
          width={"60%"}
          centered
          title={"子节点详情"}
          open={HomeStore.subNodesModal.isOpen}
          destroyOnClose={true}
          footer={null}
          onCancel={() => HomeStore.subNodesModal.close()}
      >
        <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
          <Table
              dataSource={HomeStore.subNodesDataModal}
              rowKey={(record: any) => record.username}
              scroll={{ x: 800}}
              size="small"
              className="tableSty"
              pagination={false}
          >
            <Column
                ellipsis={true}
                width={100}
                title="审批人"
                dataIndex="username"
            />
            <Column
                ellipsis={true}
                width={100}
                title="审批结果"
                dataIndex="result"
            />
            <Column
                ellipsis={true}
                width={100}
                title="审批状态"
                dataIndex="status"
                render={(status) => dictionary.approvalStatus[status]}
            />
            <Column
                ellipsis={true}
                width={140}
                title="审批时间"
                dataIndex="approvalTime"
            />
            <Column
                title="审批意见"
                width={120}
                ellipsis={true}
                dataIndex="comment"
                render={(comment) => (
                    <Tooltip placement="topLeft" title={comment}>
                      {comment}
                    </Tooltip>
                )}
            />
          </Table>
        </ConfigProvider>
      </Modal>
    </Fragment>
  );
}

export default observer(ApprovalDetails);
